"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONETRUST_SCRIPT_URL = exports.GoogleConsentTypes = exports.GoogleConsentCommand = exports.DEFAULT_ENABLED_CATEGORIES = exports.ScriptTypeAttributes = exports.ERROR_MESSAGES = exports.PACKAGE_NAME = exports.OneTrustCookieNames = exports.OneTrustCategoryIds = exports.OneTrustCategoryNames = void 0;
var OneTrustCategoryNames;
(function (OneTrustCategoryNames) {
    OneTrustCategoryNames["StrictlyNecessary"] = "Strictly Necessary Cookies";
    OneTrustCategoryNames["Performance"] = "Performance Cookies";
    OneTrustCategoryNames["Marketing"] = "Marketing Cookies";
})(OneTrustCategoryNames = exports.OneTrustCategoryNames || (exports.OneTrustCategoryNames = {}));
var OneTrustCategoryIds;
(function (OneTrustCategoryIds) {
    /**
     * @deprecated StrictlyNecessary should be used
     */
    OneTrustCategoryIds["strictlyNecessary"] = "C0001";
    /**
     * @deprecated Performance should be used
     */
    OneTrustCategoryIds["performance"] = "C0002";
    /**
     * @deprecated Marketing should be used
     */
    OneTrustCategoryIds["marketing"] = "C0004";
    OneTrustCategoryIds["StrictlyNecessary"] = "C0001";
    OneTrustCategoryIds["Performance"] = "C0002";
    OneTrustCategoryIds["Marketing"] = "C0004";
})(OneTrustCategoryIds = exports.OneTrustCategoryIds || (exports.OneTrustCategoryIds = {}));
var OneTrustCookieNames;
(function (OneTrustCookieNames) {
    OneTrustCookieNames["OptanonConsent"] = "OptanonConsent";
    OneTrustCookieNames["OptanonAlertBoxClosed"] = "OptanonAlertBoxClosed";
})(OneTrustCookieNames = exports.OneTrustCookieNames || (exports.OneTrustCookieNames = {}));
exports.PACKAGE_NAME = '@hbf/cookie-consent';
const withPackageName = (error) => `${exports.PACKAGE_NAME}: ${error}`;
exports.ERROR_MESSAGES = {
    NOT_IN_BROWSER: withPackageName('Not in a browser environment.'),
    WRONG_DOMAIN_KEY: withPackageName('Wrong domainKey'),
    LOADING_ONETRUST_SCRIPT: withPackageName('OneTrust script loading error'),
};
var ScriptTypeAttributes;
(function (ScriptTypeAttributes) {
    ScriptTypeAttributes["Plain"] = "text/plain";
    ScriptTypeAttributes["JavaScript"] = "text/javascript";
})(ScriptTypeAttributes = exports.ScriptTypeAttributes || (exports.ScriptTypeAttributes = {}));
exports.DEFAULT_ENABLED_CATEGORIES = [
    OneTrustCategoryIds.StrictlyNecessary,
];
var GoogleConsentCommand;
(function (GoogleConsentCommand) {
    /**
     *  Used to set the default consent settings that apply to a page
     */
    GoogleConsentCommand["default"] = "default";
    /**
     * Used to update existing consent settings. This command will be used
     * after a user grants consent via the OneTrust Cookie Consent application
     */
    GoogleConsentCommand["update"] = "update";
})(GoogleConsentCommand = exports.GoogleConsentCommand || (exports.GoogleConsentCommand = {}));
var GoogleConsentTypes;
(function (GoogleConsentTypes) {
    GoogleConsentTypes["denied"] = "denied";
    GoogleConsentTypes["granted"] = "granted";
})(GoogleConsentTypes = exports.GoogleConsentTypes || (exports.GoogleConsentTypes = {}));
exports.ONETRUST_SCRIPT_URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
//# sourceMappingURL=constants.js.map